import React, { useRef } from "react";
import { Grid } from "@react-three/drei";
import { useThree, useFrame } from "@react-three/fiber";

const gridConfig = {
  rotation: [1.5, 0, 0],
  position: [0, 0, -10],
  gridSize: [10, 10],
  infiniteGrid: true,
  cellColor: "#858585",
  cellSize: 1,
  cellThickness: 0.9,
  sectionSize: 10,
  sectionThickness: 1.35,
  sectionColor: "#829595",
  fadeDistance: 10000,
  fadeStrength: 0,
};
let camera;
let grid;
function GridView(props) {
  grid = props.grid;
  const gridRef = useRef(null);
  camera = useThree().camera;
  useFrame(() => {
    if (camera.zoom > 6 && camera.zoom <= 100) {
      gridRef.current.material.cellSize = 1;
      gridRef.current.material.sectionSize = 10;
    }
  });
  if (window.isWheelEventAdded != 1) {
    window.addEventListener("wheel", gridResizing(grid, gridRef, camera));
    window.isWheelEventAdded = 1;
  }

  return <Grid ref={gridRef} {...gridConfig} />;
}

function gridResizing(grid, gridRef, camera) {
  if (grid) {
    if (camera.zoom > 100) {
      gridRef.current.material.cellSize = 0.1;
      gridRef.current.material.sectionSize = 1;
    } else if (camera.zoom > 6 && camera.zoom <= 100) {
      gridRef.current.material.cellSize = 1;
      gridRef.current.material.sectionSize = 10;
    } else if (camera.zoom <= 6) {
      gridRef.current.material.cellSize = 10;
      gridRef.current.material.sectionSize = 10;
    }
  }
}

export default GridView;
